import React, { memo } from "react";
import "./MultiColorBox.css";

type Props = { colors: string[], itemColor?: any, onClick?: (checked: boolean) => void };

const MultiColorBox: React.FC<Props> = ({
    colors,
    itemColor,
    onClick
}): JSX.Element | null => {
    if (!colors || colors.length < 1) {
        return null;
    }

    const boxSize = 22;
    const borderRadius = 5;
    const marginHorizontal = 5;
    const borderWidth =  1;

const handleClick=()=>{

    console.log(itemColor);
    if(onClick){
        const checked=!(itemColor?.selected?? false);
        onClick(checked);
    }
}

    return (
        <div className="multi-color-box-container" onClick={handleClick}>
            <div 
                className="color-container"
                style={{
                    width: `${boxSize}px`,
                    height: `${boxSize}px`,
                    borderRadius: `${borderRadius}px`,
                    margin: `0 ${marginHorizontal}px`,
                    borderColor: itemColor?.selected ? 'orange' : 'lightgray',
                    borderWidth: `${borderWidth}px`,
                    borderStyle: 'solid',
                    cursor: 'pointer',
                }}
            >
                <div className="color-segments-container">
                    {colors.map((color, index) => (
                        <div
                            key={index}
                            className="color-segment"
                            style={{
                                backgroundColor: color,
                                borderRightWidth: index !== colors.length - 1 ? '0.5px' : '0',
                                borderRightColor: 'rgba(0, 0, 0, 0.2)'
                            }}
                        />
                    ))}
                </div>

            </div>
                {itemColor?.selected && itemColor?.colorCode==='' && (
                    <div className="checkmark">
                        &#10004;
                    </div>
                )}
            
        </div>
    );
};

export default memo(MultiColorBox);